import React from 'react';
import TextLabel from "../../../../../Controls/TextLabel.mjs";
import AttachmentItem from "./AttachmentItem.mjs";
import "./AttachmentList.css";
import appLib from "../../../../../libs/appLib.mjs";

const totalSize = (as) => {
	let tot = 0;
	as.forEach( a => {
		tot += a.size || 0;
	});
	return tot ? appLib.smartSize(tot) : 0;
}

const AttachmentList = class extends React.Component {
	render() {
		if (!this.props.attachments || !this.props.attachments.length) {
			return (
				<div className={"AttachmentList NoAttachments"}>
					<span>
						<TextLabel value={"NoAttachments"} />
					</span>
				</div>
			);
		}
		return(
			<div
				className={
					"AttachmentList" +
					( this.props.fullWidth ? ' fullWidth' : '' )
				}
			>
				{ this.props.summary && (
					<div className={"summary"}>
						<TextLabel value={"AttachSummary"} params={{ count: this.props.attachments.length, size: totalSize(this.props.attachments) }} />
					</div>
				)}
				<table>
					<tbody>
						{ this.props.attachments
							.filter( a => ( a.name && a.size ))
							.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
							.map((attachment, index) => (
									<AttachmentItem
										key={index}
										attachment={attachment}
										index={index}
										{...this.props}
									/>
								)
							)
						}
					</tbody>
				</table>
			</div>
		)
	}
}

export default AttachmentList;